module.exports = __webpack_public_path__ + "static/media/arrival-background.7450d5d3.jpg";